// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';

function handleTcsmCommentsChange(event) {

    this.onPipCodeTcsmCommentsChange(event.target.value);

}

function handleConfirmation() {

    this.onConfirmation(this.pipCodeRequestModalAction, this.pipCodeRequestItemToUpdate);

}

const PipCodeRequestModalBody = props =>
    <section className='pip-code-request-modal-body'>
        <div className='row'>
            <LabeledString
                className='pin'
                data={props.pipCodeRequestItemToUpdate.pin}
                label='PIN'
            />
        </div>
        <div className='row'>
            <span className='data-label tcsm-comments'>
                <FormattedMessage id='COMMENTS'/>
            </span>
            <textarea
                maxLength='120'
                onChange={props::handleTcsmCommentsChange}
            >
            </textarea>
        </div>
        <div className='button'>
            <button
                className='primary'
                disabled={!props.pipCodeRequestItemToUpdate.tcsmComments}
                onClick={props::handleConfirmation}
            >
                <FormattedMessage id='CONFIRM'/>
            </button>
        </div>
    </section>;

PipCodeRequestModalBody.displayName = 'PipCodeRequestModalBody';
PipCodeRequestModalBody.propTypes = {
    onConfirmation: PropTypes.func.isRequired,
    onPipCodeTcsmCommentsChange: PropTypes.func.isRequired,
    pipCodeRequestItemToUpdate: PropTypes.instanceOf(PipCode).isRequired,
    pipCodeRequestModalAction: PropTypes.string.isRequired
};

export default PipCodeRequestModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/pip-code-request-modal-body.js